import {useCallback} from "react";
import {useDispatch} from "react-redux";
import {IFormError} from "modules/types";
import {Action} from "redux-act";

export const useReportUserError = (action: (payload: IFormError) => Action<IFormError>) => {
	const dispatch = useDispatch();

	return useCallback(
		(error: string, place: string) => {
			dispatch(action({[place]: error}));
			return true;
		},
		[dispatch, action]
	);
};
